import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Types
import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
import type { StatusIndicatorPropsTypes } from '@Shelly/shelly-design-system/index';

type Role =
	| 'current'
	| 'power'
	| 'charged'
	| 'max_charge'
	| 'total_charge'
	| 'auto_start'
	| 'auto_balancing'
	| 'work_state';

const byRole = (statuses: VCInterfaceStatus[], role: Role) => {
	return statuses.find((s) => s?.role === role);
};

export type StatusInfo = {
	title: string;
	value: string;
	role: string;
	icon: string;
	status: VCInterfaceStatus;
};

export const buildEvTemplate = (statuses: VCInterfaceStatus[]) => {
	const power = byRole(statuses, 'power');
	const charged = byRole(statuses, 'charged');
	const current = byRole(statuses, 'current');
	const maxCharge = byRole(statuses, 'max_charge');
	const autoStart = byRole(statuses, 'auto_start');
	const totalCharge = byRole(statuses, 'total_charge');
	const autoBalancing = byRole(statuses, 'auto_balancing');
	const workState = byRole(statuses, 'work_state');
	const data = {
		current,
		max_charge: maxCharge,
		total_charge: totalCharge,
		work_state: workState,
		power,
		charged,
		auto_start: autoStart,
		auto_balancing: autoBalancing,
	};
	const statusInfo: StatusInfo[] = Object.values(data)
		.filter((status) => status && !/^(current|max_charge|auto_start|work_state)$/.test(status?.role))
		.map((status) => ({
			title: status?.vcName || status?.role,
			value: status?.rawValue !== null ? status?.value : 'N/A',
			icon: status?.icon || 'fas fa-bolt',
			role: status?.role,
			status,
		}));

	return {
		...data,
		statusInfo,
	};
};

export const getStatusIndicatorState = (state: string): StatusIndicatorPropsTypes['state'] => {
	const preDefinedStates = ['idle', 'waiting', 'paused', 'charging', 'completed', 'error'];
	if (preDefinedStates.includes(state)) {
		return state as StatusIndicatorPropsTypes['state'];
	}
	return 'idle';
};
